import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-refresh",
  "use": "icon-refresh-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-refresh\"><path d=\"M8.995 0a8 8 0 1 0 7.735 10h-2.08a6 6 0 1 1-5.655-8 5.92 5.92 0 0 1 4.223 1.78L10 7h7V0l-2.35 2.35A7.97 7.97 0 0 0 8.994 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol